/*
	Installed from https://reactbits.dev/ts/tailwind/
*/

import React from "react";

interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
  style?: React.CSSProperties;
  delay?: number;
  shineColorRgba?: string;
}

const ShinyText: React.FC<ShinyTextProps> = ({
  text,
  disabled = false,
  speed = 5,
  className = "",
  style = {},
  delay = 0,
  shineColorRgba = "rgba(60, 60, 60, 0.9)",
}) => {
  const animationDuration = `${speed}s`;

  return (
    <span className={`relative inline-block w-fit ${className}`} style={style}>
      <div className="pre-wrap w-fit">{text}</div>
      <span
        className={`absolute inset-0 bg-clip-text ${disabled ? "" : "animate-text-shine"}`}
        style={{
          backgroundImage: `linear-gradient(120deg, transparent 35%, ${shineColorRgba} 50%, transparent 65%)`,
          backgroundSize: "200% 100%",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          animationDuration: animationDuration,
          animationDelay: `${delay}s`,
        }}
        aria-hidden="true"
      >
        {text}
      </span>
    </span>
  );
};

export default ShinyText;
